import { RouteObject } from "react-router-dom";
import ErrorBoundary from "@/components/layout/ErrorBoundary";

// AI Anons sayfalarını import et
import ApiSettings from "@/pages/ai-announcements/ApiSettings";
import VoiceModelSettings from "@/pages/ai-announcements/VoiceModelSettings";
import VoiceSettingsConfig from "@/pages/ai-announcements/VoiceSettingsConfig";
import MusicCollectionManager from "@/pages/ai-announcements/MusicCollectionManager";
import UserAccessControl from "@/pages/ai-announcements/UserAccessControl";

export const aiAnnouncementRoutes: RouteObject[] = [
  {
    path: "/ai-announcements",
    children: [
      {
        index: true,
        element: <ApiSettings />,
        errorElement: <ErrorBoundary />
      },
      {
        path: "api-settings",
        element: <ApiSettings />,
        errorElement: <ErrorBoundary />
      },
      {
        path: "voice-models",
        element: <VoiceModelSettings />,
        errorElement: <ErrorBoundary />
      },
      {
        path: "voice-settings",
        element: <VoiceSettingsConfig />,
        errorElement: <ErrorBoundary />
      },
      {
        path: "music-collection",
        element: <MusicCollectionManager />,
        errorElement: <ErrorBoundary />
      },
      {
        path: "user-access",
        element: <UserAccessControl />,
        errorElement: <ErrorBoundary />
      }
    ]
  }
];
